import { html, when } from '@microsoft/fast-element';
import { PrimaryRapidColorHEX } from '../_common/colors.hex';
const progressSegments = 44;
export const zeroProgressRingTemplate = (context, definition) => html `
  <template
    role="progressbar"
    aria-valuenow="${(x) => x.value}"
    aria-valuemin="${(x) => x.min}"
    aria-valuemax="${(x) => x.max}"
    class="${(x) => (x.paused ? 'paused' : '')}"
  >
    ${when((x) => typeof x.value === 'number', html `
        <svg class="progress" part="progress" viewBox="0 0 16 16" slot="determinate">
          <defs>
            <linearGradient id="linear">
              <stop offset="0%" stop-color="${PrimaryRapidColorHEX.purple}" />
              <stop offset="60%" stop-color="${PrimaryRapidColorHEX.blue}" />
            </linearGradient>
          </defs>
          <circle class="background" part="background" cx="8px" cy="8px" r="7px"></circle>
          <circle
            class="determinate"
            part="determinate"
            style="stroke-dasharray: ${(x) => (progressSegments * x.percentComplete) / 100}px ${progressSegments}px"
            cx="8px"
            cy="8px"
            r="7px"
          ></circle>
        </svg>
      `)}
    ${when((x) => typeof x.value !== 'number', html `
        <slot name="indeterminate" slot="indeterminate">
          ${definition.indeterminateIndicator || ''}
        </slot>
      `)}
  </template>
`;
